import {useState, useEffect, memo} from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock} from '@fortawesome/free-solid-svg-icons';
import {useAlert} from '../../context/AlertContext';
import {useModal} from '../../context/ModalContext';
import useFavorite from '../../hooks/useFavorite';
import {useAuth} from '../../context/AuthContext';
import useWindowSize from '../../hooks/useWindowSize';
import './GifCard.scss';
import Classes from './GifCard.module.scss';

//== Import Icons
import LinkCopy from '../../assets/icons/copyLink.svg';
import Share from '../../assets/icons/share.svg';
import {useMixContext} from '../../context/MixContext';

const GifCard = (props: any) => {
    const {setAddAlert} = useAlert();
    const {handleCardShareModalShow} = useModal();
    const {storedUserData} = useAuth();
    const {setRelatedGifCount} = useMixContext();
    const {width} = useWindowSize();
    const [bgStyle, setBgStyle] = useState(true);

    const {favorite, setFavorite, favLoading, unFavLoading, toggleFavorite} = useFavorite();
    //== Browser detect
    const [safari, setSafari] = useState(false);
    useEffect(() => {
        let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;
        let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
        if ((chromeAgent) && (safariAgent)) safariAgent = false;
        if (safariAgent) {
            setSafari(true);
        }
    }, []);

    //== Copy link to clipboard
    const copyUrlClipboard = async () => {
        await navigator?.clipboard?.writeText(`${process.env.REACT_APP_MEDIA_SERVER}/${props?.filePath}`);
        setAddAlert({
            alertType: 'default',
            alertMessage: 'Gif Link Copied to Clipboard!'
        })
    }

    useEffect(() => {
        setFavorite(storedUserData?.favouriteImages?.includes(props?._id));
        // eslint-disable-next-line
    }, [props?._id]);


    return (
        <div
            className={`${Classes.cardWrap} ${bgStyle ? '' : Classes.bgStyle}`}
        >
            <Link
                to={`/gif/${encodeURIComponent(props?.slug)}/${encodeURIComponent(props?.filePath?.replace('resources/', ''))}`}
                state={props}
                className={Classes.gifWrap}
                style={{height: '100%'}}
                onClick={() => setRelatedGifCount(1)}
            >
                {(safari || props?.sticker) ? (
                    <img
                        src={`${process.env.REACT_APP_MEDIA_SERVER}/${props?.filePath}${props?.sticker ? '' : '-200px'}`}
                        alt={props?.title}
                        className={Classes.imageGif}
                        onLoad={() => setBgStyle(false)}
                    />
                ) : (
                    <video
                        src={`${process.env.REACT_APP_MEDIA_SERVER}/${props?.filePath}-200.mp4`}
                        autoPlay={true}
                        muted={true}
                        loop={true}
                        playsInline={true}
                        className={Classes.videoPlayer}
                        onLoadedMetadata={() => setBgStyle(false)}
                    />
                )}
            </Link>


            {props?.visibility === false ? (
                <><FontAwesomeIcon icon={faLock} className={Classes.privateIcon}/></>
            ) : null}

            {(width >= 768) ? (
                <div className={Classes.cardOverlay}>
                    {!props.relatedTagsView && (
                        <ul className={Classes.tags}>
                            {props?.tags?.split(',').map((tag: any, i: number) => (
                                <li key={i}>
                                    {(tag.trim()) && (
                                        <Link
                                            to={`/search/${tag}`}
                                            state={Array(tag.trim())}
                                        >
                                            #{tag?.trim()}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}

                    {(!props.favLinkShare && props?.visibility) && (
                        <ul className={`${Classes.favLinkShare} favLinkShareWrap`}>
                            <li>
                                <button
                                    onClick={() => toggleFavorite(props?._id, props?.queryInvalidateKey)}
                                    disabled={favLoading || unFavLoading}
                                    className={favorite ? 'favBtnAnimation' : 'unFavBtnAnimation'}
                                >
                                    <svg id="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g id="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z"
                                                  id="heart"
                                                  fill="#fff"
                                            />
                                            <circle id="main-circ" fill="#E2264D" opacity="0" cx="29.5" cy="29.5" r="1.5"/>

                                            <g id="grp7" opacity="0" transform="translate(7 6)">
                                                <circle id="oval1" fill="#9CD8C3" cx="2" cy="6" r="2"/>
                                                <circle id="oval2" fill="#8CE8C3" cx="5" cy="2" r="2"/>
                                            </g>

                                            <g id="grp6" opacity="0" transform="translate(0 28)">
                                                <circle id="oval1" fill="#CC8EF5" cx="2" cy="7" r="2"/>
                                                <circle id="oval2" fill="#91D2FA" cx="3" cy="2" r="2"/>
                                            </g>

                                            <g id="grp3" opacity="0" transform="translate(52 28)">
                                                <circle id="oval2" fill="#9CD8C3" cx="2" cy="7" r="2"/>
                                                <circle id="oval1" fill="#8CE8C3" cx="4" cy="2" r="2"/>
                                            </g>

                                            <g id="grp2" opacity="0" transform="translate(44 6)">
                                                <circle id="oval2" fill="#CC8EF5" cx="5" cy="6" r="2"/>
                                                <circle id="oval1" fill="#CC8EF5" cx="2" cy="2" r="2"/>
                                            </g>

                                            <g id="grp5" opacity="0" transform="translate(14 50)">
                                                <circle id="oval1" fill="#91D2FA" cx="6" cy="5" r="2"/>
                                                <circle id="oval2" fill="#91D2FA" cx="2" cy="2" r="2"/>
                                            </g>

                                            <g id="grp4" opacity="0" transform="translate(35 50)">
                                                <circle id="oval1" fill="#F48EA7" cx="6" cy="5" r="2"/>
                                                <circle id="oval2" fill="#F48EA7" cx="2" cy="2" r="2"/>
                                            </g>

                                            <g id="grp1" opacity="0" transform="translate(24)">
                                                <circle id="oval1" fill="#9FC7FA" cx="2.5" cy="3" r="2"/>
                                                <circle id="oval2" fill="#9FC7FA" cx="7.5" cy="2" r="2"/>
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </li>
                            <li>
                                <button onClick={copyUrlClipboard}>
                                    <img src={LinkCopy} alt="LinkCopy" className={'img-fluid'}/>
                                </button>
                            </li>
                            <li>
                                <button onClick={() => handleCardShareModalShow(props?._id)}>
                                    <img src={Share} alt="Share" className={'img-fluid'}/>
                                </button>
                            </li>
                        </ul>
                    )}
                </div>
            ) : null}
        </div>
    );
};

export default memo(GifCard);